import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./Components/Home/Home";
import reportWebVitals from "./reportWebVitals";
import { SSEProvider } from "./Components/SSE/SSEProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
  <SSEProvider>
    <Home />
  </SSEProvider>,
  //</React.StrictMode>
);

reportWebVitals();
